import PostShare from './PostShare';

export default PostShare;
export * as PostShareStyles from './PostShare.styles';
export * as PostShareTypes from './PostShare.types';
